/** @jsxImportSource @emotion/react */

import React from "react";
import Immutable from "immutable";

import Drawer from "js/common/views/drawer";
import ScheduleFormContent from "js/dashboards/scheduling/schedule-form-content";

const ScheduleDrawer = React.memo(
  ({
    open,
    onRequestClose,
    configId,
    idToDashboard,
    SavedConfigs,
    scheduleToEdit,
    cloneFromId,
    onScheduleUpdate,
    onCloneClick,
    existingSchedules = Immutable.List(),
    addNewMode = false,
    idToScheduledReport
  }) => {
    const DRAWER_WIDTH = "80%";
    const [isClonedFromEdit, setIsClonedFromEdit] = React.useState(false);

    const isEditMode = !!scheduleToEdit && !isClonedFromEdit;
    const isCloneMode = (!!cloneFromId && !scheduleToEdit) || isClonedFromEdit;

    const cloneFromIdObject = cloneFromId ? idToScheduledReport?.get(cloneFromId) : null;

    const dashboardId = scheduleToEdit?.get("dashboardId") || cloneFromIdObject?.get("dashboardId") || configId;
    const originalName = scheduleToEdit?.get("name") || cloneFromIdObject?.get("name") || `${idToDashboard.getIn([dashboardId, "name"])} Report`;
    const drawerTitle = isEditMode ? `Editing ${originalName}` : isCloneMode ? `Cloning ${originalName}` : `New Scheduled Report`;

    // Reset cloned state when drawer closes or reopens with different schedule
    React.useEffect(() => {
      setIsClonedFromEdit(false);
    }, [open, scheduleToEdit, cloneFromId]);

    const handleCloneFromEdit = React.useCallback(() => {
      setIsClonedFromEdit(true);
      if (onCloneClick) {
        onCloneClick();
      }
    }, [onCloneClick]);

    return (
      <Drawer
        dataProductId={open ? "schedule-drawer-open" : "schedule-drawer-closed"}
        dataTestId={"schedule-drawer"}
        width={DRAWER_WIDTH}
        onRequestClose={onRequestClose}
        open={open}
        title={drawerTitle}
        showCloseButton
        disableRestoreFocus={true}
        openRight={true}
      >
        {open && (
          <ScheduleFormContent
            configId={configId}
            idToDashboard={idToDashboard}
            SavedConfigs={SavedConfigs}
            scheduleToEdit={scheduleToEdit}
            cloneFromId={cloneFromId}
            idToScheduledReport={idToScheduledReport}
            onScheduleUpdate={onScheduleUpdate}
            onCloneClick={handleCloneFromEdit}
            existingSchedules={existingSchedules}
            addNewMode={addNewMode}
            onRequestClose={onRequestClose}
            isClonedFromEdit={isClonedFromEdit}
          />
        )}
      </Drawer>
    );
  }
);

export default ScheduleDrawer;
